import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../stores/actionsList";
import { translate } from '../../utils/useful';
import TextAreaInput from '../../components/inputs/TextAreaInput';

class SingleProductAdditionals extends Component {

    state = {

        save: false,
        collapsOpen: { 0: true },

        info: {
            available: true,
            status: 1
        },

        activeVariants: {},
        variantsPriceDifferences: {},

    }




    changeAdditional = (additional, option, isSelected) => {

        let activeAdditionals = this.props.activeAdditionals ? { ...this.props.activeAdditionals } : {}


        if (additional.type == 'text') {
            activeAdditionals[additional.title] = { text: { value: option } }
            if (!option || option.trim == '') {
                delete activeAdditionals[additional.title]
            }
            // this.setState({ activeAdditionals })
            this.props.setActiveAdditionals(activeAdditionals)
            return
        }


        if (additional.type == 'singleSelect') {
            delete activeAdditionals[additional.title]
        }

        if (!activeAdditionals[additional.title]) {
            activeAdditionals[additional.title] = {}
        }



        if (isSelected) {
            delete activeAdditionals[additional.title][option.label]
        } else {
            activeAdditionals[additional.title][option.label] = { value: true, priceDifference: option.priceDifference }
        }

        if (Object.keys(activeAdditionals[additional.title]).length == 0) {
            delete activeAdditionals[additional.title]
        }

        this.props.setActiveAdditionals(activeAdditionals)
        // this.setState({ activeAdditionals })


    }


    render() {

        return (

            <div className=''>
                {Array.isArray(this.props?.product?.additionals) == true && this.props?.product?.additionals.map((additional, index) => {
                    return (
                        <div className='mb-3 '>
                            <div className='flexcb mb-2'>
                                <p className='font-size-16 text-bold text-normal '>{additional?.title}</p>
                                {additional.required && (
                                    <div className='br-20 px-2 py-1' style={{ backgroundColor: '#eee' }}>
                                        <p className='text-smaller text-semibold'>{translate("Required")}</p>
                                    </div>
                                )}
                            </div>
                            <div className='mt-3'>

                                {(additional.type == 'text') && (
                                    <div className='bordered-input p-2'>
                                        <TextAreaInput data={this.props.activeAdditionals ? this.props.activeAdditionals[additional.title]?.text?.value : ''} header={{ information: { rows: 4, placeholder: '{{lang}}Add a note' } }} changeValue={(key, value) => this.changeAdditional(additional, value)} />
                                    </div>
                                )}


                                {Array.isArray(additional.options) && additional.options.map((option, index) => {

                                    let isSelectedVariant = false

                                    if (this.props.activeAdditionals && this.props.activeAdditionals[additional.title]) {
                                        let activeAdditional = this.props.activeAdditionals[additional.title]

                                        if (activeAdditional && activeAdditional[option.label]) {
                                            isSelectedVariant = true
                                        }
                                    }

                                    return (
                                        <div className=' mrd-2 mb-3  w-100'>
                                            <button className='flexcb pb-3 w-100' onClick={() => this.changeAdditional(additional, option, isSelectedVariant)} style={{ borderBottom: '1px solid #eee' }}>
                                                <div className='text-start'>
                                                    <p className='text-small text-semibold'>{option.label}</p>

                                                    {(option.priceDifference != null && option.priceDifference != 0) && (
                                                        <p className='text-small  ' style={{ color: '#000' }}>{option.priceDifference > 0 ? "+" : ''}${option.priceDifference}</p>
                                                    )}
                                                </div>

                                                <div className='br-4 px-3 py-1 flexc' >

                                                    {additional.type == 'singleSelect' && (

                                                        <label className="checkbox-container " >
                                                            <input type="checkbox" checked={isSelectedVariant} />
                                                            <span className="radioMark"></span>
                                                        </label>

                                                    )}

                                                    {(additional.type == 'multiSelect' || !additional.type) && (
                                                        <label className="checkbox-container " >
                                                            <input type="checkbox" checked={isSelectedVariant} />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    )}



                                                </div>
                                            </button>
                                        </div>
                                    )

                                })}
                            </div>
                        </div>
                    )
                })}

            </div >

        )
    }
}

export default SingleProductAdditionals
